import { render, staticRenderFns } from "./editConsultation.vue?vue&type=template&id=543b8d4c&scoped=true"
import script from "./editConsultation.vue?vue&type=script&lang=js"
export * from "./editConsultation.vue?vue&type=script&lang=js"
import style0 from "./editConsultation.vue?vue&type=style&index=0&id=543b8d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b8d4c",
  null
  
)

export default component.exports